 <template>
  <div class="loginBox">
    <p class="titles">车检速培</p>
    <div class="boxContent">
      <h1>忘记密码</h1>
      <el-form
        :model="registerForm"
        class="form"
        validate-on-rule-change
        :rules="dataRule"
        ref="loginForm"
      >
        <el-form-item prop="mobile">
          <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="registerForm.code" placeholder="请输入验证码">
            <el-button slot="append">
              <span v-show="show" @click="getCode">获取验证码</span>
              <span v-show="!show">{{count}} s</span>
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="registerForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="registerForm.repassword" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" style="width:100%" @click="actionRegister">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="login-logo">
      <div class="container">
        <img src="https://image4.suning.cn/uimg/cms/img/155540698836163295.png" alt srcset />
      </div>
    </div>
    <div class="login">
      <div class="container back-img">
        <img src="https://img.alicdn.com/tfs/TB1gEXbFEY1gK0jSZFCXXcwqXXa-1190-600.jpg" />
        <div class="login-form">
          <el-card>
            <div class="tab">
              <div>重置密码</div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <Footer style="background:#fff;"></Footer>-->
  </div>
</template>
<script>
import Footer from "@/components/footer/Footer";
export default {
  components: {
    Footer
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error("密码长度为6 - 18个字符"));
      } else {
        callback();
      }
    };
    var checkphone = (rule, value, callback) => {
      let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneReg.test(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        mobile: "",
        password: "",
        repassword: "",
        code: ""
      },
      dataRule: {
        mobile: {
          required: true,
          validator: checkphone,
          trigger: "blur"
        },
        code: {
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        },
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ]
      },
      show: true,
      count: "",
      timer: null
    };
  },

  created() {},

  methods: {
    actionRegister() {
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: "/api/v1/reset-password",
            method: "post",
            data: this.registerForm
          })
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.back();
                  }
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              if (err.response) {
                let data = err.response.data;
                if (data.errors) {
                  if (data.errors.mobile) {
                    this.$message.error(data.errors.mobile[0]);
                  } else {
                    this.$message.error(data.message);
                  }
                }
                console.log(err.response);
              }
            });
        }
      });
    },
    getCode() {
      if (!this.registerForm.mobile) {
        this.$message.error("请输入手机号");
        return false;
      }
      this.$http({
        url: "/api/v1/captcha/send",
        method: "post",
        data: { mobile: this.registerForm.mobile, type: "10001" }
      })
        .then(res => {
          if (res.status == 200) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          if (err.response) {
            let data = err.response.data;
            if (data.errors) {
              if (data.errors.mobile) {
                this.$message.error(data.errors.mobile[0]);
              } else {
                this.$message.error(data.message);
              }
            }
            console.log(err.response);
          }
        });
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.loginBox {
  background-image: url("../../assets/image/login.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100vh;
  position: relative;
  .titles {
    text-align: center;
    padding: 80px 20px 30px;

    width: 100%;
    letter-spacing: 7px;
    color: rgba(255, 255, 255, 1);
    font-size: 44px;
    line-height: 150%;

    font-weight: bold;
  }
  .boxContent {
    width: 400px;
    position: absolute;
    right: 13.6%;
    top: 230px;

    border-radius: 10px;
    background-color: #fff;
    h1 {
      text-align: center;
      padding-top: 20px;
    }
    .form {
      a {
        color: #4254fd;
      }
    }
  }
}
.el-tabs__nav {
  width: 100%;
}
.login {
  background-color: rgb(198, 235, 253);
}
.login-form {
  position: absolute;
  width: 460px;
  min-height: 500px;
  top: 50px;
  right: 0px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid #e4ecf3;
}
.form {
  width: 338px;
  margin: 0 auto;
  padding: 40px 0;
  .form-box {
    margin-bottom: 20px;
    overflow: hidden;
    label {
      color: rgba(0, 0, 0, 0.56);
      display: inline-block;
      width: 100%;
      margin-bottom: 5px;
      font-weight: 700;
    }
  }
  .code {
    width: 250px;
    float: left;
    border: none;
  }
  .count {
    float: right;
    text-align: center;
    border-radius: 4px;
    display: block;
    width: 80px;
    line-height: 40px;
    color: #fff;
    background-color: rgba(52, 105, 250, 1);
  }
}

.login-button {
  margin-top: 40px;
  width: 338px;
  line-height: 44px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(52, 105, 250, 1);
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}
.tab {
  height: 80px;
  font-size: 25px;
  text-align: center;
  color: rgba(66, 84, 253, 1);
  margin: 10px 0 20px;
  div {
    width: 100%;
    height: 100%;
    line-height: 80px;
  }
}
.login-logo {
  height: 72px;
  img {
    height: 72px;
    float: left;
  }
}
.back-img {
  position: relative;
  height: 600px;
  img {
    height: 100%;
    width: 100%;
  }
}
</style>